<template>
  <div>
    <div class="grid grid-cols-3 font-heiti text-sm pt-1">
      <div class="col-span-3 flex">
        <div>评测机构：</div>
        <div class="space-x-5">
          <span>吉林吉大通信设计院股份有限公司</span>
          <span>吉林省电子技术研究所</span>
        </div>
      </div>
      <div class="col-span-1">
        项目总负责人：<img class="inline h-6" ref="five" alt="" src="" />
      </div>
      <div class="col-span-1">
        项目总工程师：<img class="inline h-6" ref="six" alt="" src="" />
      </div>
      <div class="col-span-1 text-right">
        第 {{ page }} 页（共 {{ total }} 页）
      </div>
    </div>
  </div>
</template>

<script>
// 页脚
import { getFile } from "@/api/enterprise";

export default {
  props: ["info", "page", "total"],
  mounted() {
    this.getAvatar(this.info.strFive).then((url) => {
      this.$refs.five.src = url;
    });
    this.getAvatar(this.info.strSix).then((url) => {
      this.$refs.six.src = url;
    });
  },
  methods: {
    async getAvatar(id) {
      try {
        const res = await getFile(id);
        return URL.createObjectURL(res.data);
      } catch (error) {
        console.error("image load fail");
      }
    },
  },
};
</script>
